import { useEffect, useState } from 'react';
import { companiesApi, lookupApis } from '../../admin/admin.api';

export interface Option {
  id: number;
  label: string;
}

/**
 * The financial years and companies the bill screens filter by. The year starts on the active
 * one, so the screens open on the current year's bills.
 */
export default function useBillingFilters() {
  const [years, setYears] = useState<Option[]>([]);
  const [companies, setCompanies] = useState<Option[]>([]);
  const [financialYearId, setFinancialYearId] = useState<number | ''>('');
  const [companyId, setCompanyId] = useState<number | ''>('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let live = true;
    Promise.all([lookupApis.financialYears.list(), companiesApi.list()])
      .then(([fy, co]) => {
        if (!live) return;
        const sortedYears = [...fy].sort((a, b) => String(b.label ?? '').localeCompare(String(a.label ?? '')));
        setYears(sortedYears.map((y) => ({ id: y.id, label: String(y.label ?? y.code) })));
        setCompanies(co.map((c: any) => ({ id: c.id, label: c.name })));
        const active = fy.find((y) => y.isActive);
        if (active) setFinancialYearId(active.id);
      })
      .catch(() => {
        // Filters only narrow the list; without them every year and company is shown.
      })
      .finally(() => live && setReady(true));
    return () => {
      live = false;
    };
  }, []);

  return { years, companies, financialYearId, setFinancialYearId, companyId, setCompanyId, ready };
}
